import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  overflow: "auto",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  bgcolor: "background.paper",
  p: 2,
  height: "100vh",
};

export default function TotalDescription(props) {
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <div className="Description" onClick={() => setOpen(true)}>
        <span>توضیحات کامل</span>
        <img src="/public/assets/icons/anotherVendors.svg" alt="pic" />
      </div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          zIndex:"99999"
        }}
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div className="Technical">
              <div className="HeadReturn">
                <span>مشخصات فنی</span>
                <span className="close" onClick={() => setOpen(false)}>
                  &times;
                </span>
              </div>
              {props.features.map((feature) => (
                <div className="DescriptionText">
                  <span className="Title">{feature.feature}:</span>
                  <span className="Text">{feature.value}</span>
                </div>
              ))}
              <p className="TechnicalContent">توضیحات تکمیلی</p>
              <p>{props.title ? props.title : "مشخصات فنی وجود ندارد"}</p>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
